import Text from '@/components/atoms/Text';
import * as S from './styles';
import Link from '@/components/atoms/Link';

export type TextoTermosChippuProps = {
  highConstrast?: boolean;
  primeiroTexto?: string;
  ultimoTexto?: string;
  mostrarPoliticaPrivacidade?: boolean;
};

export default function TextoTermosChippu(props: TextoTermosChippuProps) {
  const {
    highConstrast = false,
    primeiroTexto = 'Li e aceito os ',
    ultimoTexto = undefined,
    mostrarPoliticaPrivacidade = true,
  } = props;
  return (
    <S.ContainerTextos>
      <Text
        $size={2}
        $color="neutral"
        $weight="medium"
        $align="center"
        $highContrast={highConstrast}
        $text={primeiroTexto}
      />
      <Link
        $size={2}
        $color="accent"
        $weight="bold"
        $underline={true}
        $highContrast={highConstrast}
        $text={'Termos de uso'}
        href={`/termos?tipoTermo=termosDeServico`}
        $abrirNovaGuia={true}
        style={{
          whiteSpace: 'nowrap',
        }}
      />
      {mostrarPoliticaPrivacidade ? (
        <S.ContainerTextos>
          <Text
            $size={2}
            $color="neutral"
            $weight="medium"
            $align="center"
            $highContrast={highConstrast}
            $text=" e "
          />
          <Link
            $size={2}
            $color="accent"
            $weight="bold"
            $underline={true}
            $highContrast={highConstrast}
            $text={'Termos de privacidade'}
            href={`/termos?tipoTermo=politicaPrivacidade`}
            $abrirNovaGuia={true}
            style={{
              whiteSpace: 'nowrap',
            }}
          />
        </S.ContainerTextos>
      ) : null}
      {ultimoTexto ? (
        <Text
          $size={2}
          $color="neutral"
          $weight="medium"
          $align="center"
          $highContrast={highConstrast}
          $text={ultimoTexto}
        />
      ) : null}
    </S.ContainerTextos>
  );
}
